import './onboarding.css';

// Thin champagne thread. No numerals, no percentage, no step badges.
export const OnboardingProgressThread = ({ step, total }) => {
  const pct = `${(step / total) * 100}%`;

  return (
    <div
      className="onb-thread"
      role="progressbar"
      aria-label="Onboarding progress"
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={step}
      aria-valuetext={`Screen ${step} of ${total}`}
      data-testid="onboarding-progress-thread"
    >
      <div className="onb-thread__fill" style={{ width: pct }} />
      <div className="onb-thread__ember" style={{ left: pct }} />
    </div>
  );
};

export default OnboardingProgressThread;
